import { takeEvery, put, call } from "redux-saga/effects"
import { NotifHelper } from "../../components/Common/NotifHelper"

import {
    GET_DATA,
    CLEAR_DATA
} from "./actionTypes"
import {
    getDataSuccess,
    getDataFail,
    clearDataSuccess
} from "./actions"

//Include Both Helper File with needed methods
import {
    getDataTable,
} from "../../helpers/backend_helper"

function* fetchListData({ payload: { url, page, length, filter } }) {
    if(filter.companyId){
        try {
            const response = yield call(getDataTable, url, page, length, filter)
            if (response.status) {
                yield put(getDataSuccess(response.data))
            }
            else {
                NotifHelper.error(response.message)
                yield put(getDataFail(response.message))
            }
        } catch (error) {
            NotifHelper.error(error)
            yield put(getDataFail(error))
        }
    }
    else{
        yield put(getDataSuccess({
            length: 10,
            list: [],
            page: 1,
            totalData: 0,
            totalPage: 1,
        }))
    }
}

function* onclearData (){
    yield put(clearDataSuccess())
}

function* dataTableSaga() {
    yield takeEvery(GET_DATA, fetchListData)
    yield takeEvery(CLEAR_DATA, onclearData)
}

export default dataTableSaga